import { render, staticRenderFns } from "./SiteBrands.vue?vue&type=template&id=567cfbe7"
import script from "./SiteBrands.vue?vue&type=script&lang=js"
export * from "./SiteBrands.vue?vue&type=script&lang=js"
import style0 from "./SiteBrands.vue?vue&type=style&index=0&id=567cfbe7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports